// extracted by mini-css-extract-plugin
export default {"back":"TM539","qr-code":"NPx4v","step-number":"QWxbm","alternative":"oe9S8","alternative--selected":"TWerz"};